import React, { Fragment } from "react";
import { Link as RouterLink } from "react-router-dom";

import Box from "@material-ui/core/Box";
import Chip from "@material-ui/core/Chip";
import Link from "@material-ui/core/Link";
import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";

import CollectionsIcon from "@material-ui/icons/Collections";

import {
  MEDIA_THUMBNAIL_URL,
  PLACEHOLDER_IMG_360x360_URL,
  PLACEHOLDER_IMG_360x360_ERROR_URL,
  IMG_BG_COLOR,
} from "../../config";
import StatusChip from "./StatusChip";
import KeyValue from "../display/KeyValue";
import AdmAreaBreadcrumbs from "./AdmAreaBreadcrumbs";
import { fromUnixtime } from "../../utils/time";
import UserChip from "../user/UserChip";
import ListItem from "../display/ListItem";

const useStyles = makeStyles((theme) => ({
  paper: {
    padding: theme.spacing(2),
    margin: "auto",
    //backgroundColor: "#212121",
    marginTop: theme.spacing(1),
  },
  img: {
    width: 200,
    height: 110,
    margin: "auto",
    objectFit: "cover",
    backgroundColor: IMG_BG_COLOR,
  },
  breadcrumb: {
    justifyContent: "center",
    flexWrap: "wrap",
    paddingLeft: "0px",
  },
  chip: {
    margin: theme.spacing(1),
    marginLeft: "0px",
    height: "100%",
    padding: "2px"
  },
}));

export default function ResultGrid({ location }) {
  const classes = useStyles();
  return (
    <Paper className={classes.paper}>
      <ListItem
        header={
          <Fragment>
            <Link
              color="inherit"
              component={RouterLink}
              to={`/location/${location.id}`}
              underline="none"
              variant="subtitle2"
            >
              {`${location.name} ( ${location.id} )`}
            </Link>
            {!!location.adm && <AdmAreaBreadcrumbs admDetails={location.adm} />}
          </Fragment>
        }
        contentLeft={
          <Box
            display="flex"
            flexDirection="column"
            alignItems="center"
            height="100%"
            style={{ marginTop: 10 }}
          >
            <Box>
              <img
                className={classes.img}
                alt=""
                src={
                  !!location.mediaId
                    ? `${MEDIA_THUMBNAIL_URL}/${location.mediaId}?width=240`
                    : PLACEHOLDER_IMG_360x360_URL
                }
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src = PLACEHOLDER_IMG_360x360_ERROR_URL;
                }}
              />
            </Box>
            <Box>
              <StatusChip status={location.status} />
            </Box>
            <Typography
              variant="caption"
              display="block"
              color="textSecondary"
              gutterBottom
            >
              {fromUnixtime(location.createdOn)}
            </Typography>

            <Box display="flex" flexDirection="row">
              <CollectionsIcon style={{ fontSize: 20, color: "#C2C2C2" }} />
              <Fragment>
                {location.mediaCount !== null &&
                  location.mediaCount !== undefined
                  ? ` : ${location.mediaCount}`
                  : ` : 0`}
              </Fragment>
            </Box>
          </Box>
        }
        contentRight={
          <Fragment>
            <KeyValue keyName="Address" value={location.address} />
            <KeyValue keyName="Short Description" value={location.caption} />
            <KeyValue
              keyName="External Link"
              link={location.link}
              value={location.link}
              external
            />
            <UserChip user={location.createdBy} />
            {!!location.category && (
              <KeyValue
                keyName="Categories"
                value={
                  <Fragment>
                    {location.category.map((cat) => {
                      return (
                        <Chip
                          size="small"
                          // variant="outlined"
                          // label={`${cat.categoryName} : ${cat.subCategoryName}`}
                          label={<Typography
                            variant="caption"
                            style={{ whiteSpace: 'normal' }}>
                            {`${cat.categoryName} : ${cat.subCategoryName}`}
                          </Typography>}
                          className={classes.chip}
                          key={cat.subCategoryId}
                          style={{
                            backgroundColor: cat.categoryColor || "#616161",
                          }}
                        />
                      );
                    })}
                  </Fragment>
                }
              />
            )}
          </Fragment>
        }
      />
    </Paper>
  );
}
